import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import { useNavigate, useLocation, Link } from 'react-router-dom';
import type {Iappliance} from '../../types'

interface OwlCarouselComponentProps {
  heading:string;
  description?:string;
  data:Iappliance[];
}
const OwlCarouselComponent: React.FC<OwlCarouselComponentProps> = ({heading, description, data}) => {
  
const navigate = useNavigate();

  const handleClickAddToCart = (slug: any) => {
      
    navigate(`${slug}`);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };


  const handleSellNow = (slug:string) =>{
    const path = (slug.trim());
      
    navigate(path);
    // window.scrollTo({ top: 0, behavior: 'smooth' });
  }
  
  if(data?.length == 0 || data === undefined){
    return(
      <div></div>
    )
  }

  const settings = {
    dots: false, // Enable navigation dots
    infinite: data.length >=3, // Infinite scrolling
    speed: 700, // Transition speed in milliseconds
    slidesToShow: data.length >= 3 ? 4 : 4, // Number of slides to show at once
    slidesToScroll: 1, // Number of slides to scroll at a time
    autoplay: true, // Enable autoplay
    autoplaySpeed: 3000, // Autoplay interval in milliseconds
    
    responsive: [
      {
        breakpoint: 1024, // For screens less than 1024px
        settings: {
          slidesToShow: data.length >= 3 ? 3 : 4, // Show 3 slides
          slidesToScroll: 1, // Scroll 1 slide at a time
        },
      },
      {
        breakpoint: 768, // For screens less than 768px
        settings: {
          slidesToShow: 3, // Show 2 slides
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480, // For screens less than 480px
        settings: {
          slidesToShow: 3, // Show 1 slide
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <section className="featured heavy">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <h2 className="Appliances-top-home-page"> {heading}</h2>
            <Slider {...settings}>
              {data.length > 0 ? (
                data.map((appliance, index) => (
                  <div className="item" key={index} onClick={() => handleClickAddToCart(appliance.slug)} >
                    <div className="fetur_pro_img">
                      <img loading="lazy" src={appliance.image} alt={`${appliance.name}`} width="282" height="226" style={{ maxWidth:"100%", height:"auto"}} />
                    </div>
                    <div className="fetur_pro_img_description">
                      <p className="fe_pro_name">{appliance.name}</p>
                      <div className="wrap_div d-flex justify-content-between align-items-center">
                        <p className="fe_pro_price">
                          <span className="light_color_txt">Get Up to : </span>
                          <br className="m-none" />₹ {appliance.price}
                        </p>
                        <a
                          className="d-inline-block- web_view"
                          onClick={(e) => {
                            e.stopPropagation();
                            handleSellNow(appliance.slug) }
                          }
                        >
                          Sell Now
                        </a>
                        <a
                          className="d-inline-block- mob_view"
                          onClick={() => handleClickAddToCart(appliance.slug)}
                        >
                          <i className="fa-solid fa-plus"></i>
                        </a>
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                null
              )}
            </Slider>

          </div>
        </div>
      </div>
    </section>
  );
};

export default OwlCarouselComponent;
